const VideoPlayer = () => {
  // const [isPlaying, setIsPlaying] = useState(false)
  // const videoRef = useRef(null)

  // const handleTogglePlay = () => {
  //   if (videoRef.current.paused) {
  //     videoRef.current.play()
  //     setIsPlaying(true)
  //   } else {
  //     videoRef.current.pause()
  //     setIsPlaying(false)
  //   }
  // }

  return (
    <div className="group relative h-full max-h-[563px] w-full max-w-[1000px] overflow-hidden rounded-2xl border-[#DADADA] shadow-[4px_4px_20px_0px_#0000001A]">
      <div
        className="wistia_responsive_padding"
        style={{ padding: '56.25% 0 0 0', position: 'relative' }}
      >
        <div
          className="wistia_responsive_wrapper"
          style={{
            height: '100%',
            left: 0,
            position: 'absolute',
            top: 0,
            width: '100%',
          }}
        >
          <iframe
            src="https://fast.wistia.net/embed/iframe/gxs87n8y2s?seo=true&videoFoam=true"
            title="dayai-video-final"
            allow="autoplay; fullscreen"
            // eslint-disable-next-line react/no-unknown-property
            allowtransparency="true"
            frameBorder="0"
            scrolling="no"
            className="wistia_embed"
            name="wistia_embed"
            // eslint-disable-next-line react/no-unknown-property
            msallowfullscreen
            width="100%"
            height="100%"
          ></iframe>
        </div>
      </div>
    </div>
  )
}

export default VideoPlayer
